import { Table } from "./table"
import { TableHeader } from "./components/column-header"
import { NeighbourhoodLikeNameCell } from "./components/cell-neighbourhood-like-name"
import { TesGainCell } from "./components/cell-tes-gain"
import { TargetScoreBar } from "./components/target-score-bar"
import {
  NeighbourhoodLikeScoreHeader,
  TargetScoreHeader,
} from "./components/neighbourhood-like-score-header"
import { HigherAdminCell } from "./components/cell-higher-admin-name"

export {
  Table,
  TableHeader,
  NeighbourhoodLikeNameCell,
  TesGainCell,
  TargetScoreBar,
  NeighbourhoodLikeScoreHeader,
  HigherAdminCell,
  TargetScoreHeader,
}
